import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import RemoteImageReferralDetailContainer from '../../../containers/remoteImage/referral/RemoteImageReferralDetailContainer';
import {
  REMOTE_REFERRAL_IMAGE_PAGE_NAME,
  REMOTE_IMAGE_DETAIL_PAGE_TYPE,
} from '../../../constants/service/app/remoteImageConstants';

const RemoteImageReferralCreate = () => {
  return (
    <PageTemplate pageName={REMOTE_REFERRAL_IMAGE_PAGE_NAME.REMOTE_REFERRAL_IMAGE_CREATE}>
      <RemoteImageReferralDetailContainer detailPageType={REMOTE_IMAGE_DETAIL_PAGE_TYPE.CREATE} />
    </PageTemplate>
  );
};

export default RemoteImageReferralCreate;
